(function () {
  'use strict';

  const originalFetch = window.fetch;
  const intentLifetimeMs = 5000;
  let pendingIntent = null;

  function reportTrackingError(message) {
    const error = new Error(`Jiniu add_to_cart tracking: ${message}`);
    if (typeof window.reportError === 'function') {
      window.reportError(error);
    } else {
      window.setTimeout(function () { throw error; }, 0);
    }
  }

  function isAddUrl(value) {
    if (!String(value || '').includes('/cart/add')) return false;
    try {
      const url = new URL(value, window.location.href);
      return url.origin === window.location.origin && /(?:^|\/)cart\/add(?:\.js)?\/?$/.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function moduleName(value) {
    const names = {
      MainProductPage: 'product_detail',
      FeaturedProductSection: 'featured_product',
      ProductRecommendations: 'product_recommendations',
      FeaturedCollectionSection: 'featured_collection',
      TabbedProductListsSection: 'tabbed_product_lists',
      ComplementaryProducts: 'complementary_products',
      ProductAddons: 'product_addons',
      ProductAddonsDrawer: 'product_addons_drawer',
      MiniCart: 'mini_cart',
      CartPage: 'cart_page',
      SearchPage: 'search_results',
      PredictiveSearch: 'predictive_search',
      ProductVideoCard: 'product_video_card'
    };
    return names[value] || String(value || 'other').replace(/([a-z])([A-Z])/g, '$1_$2').replace(/[^a-zA-Z0-9]+/g, '_').toLowerCase();
  }

  function positionOf(element) {
    const position = Number(element?.closest('[data-jiniu-property-position]')?.getAttribute('data-jiniu-property-position'));
    return Number.isInteger(position) && position > 0 ? position : '';
  }

  function buttonText(button) {
    const label = button.querySelector('span:not(.spinner-xs):not(.visually-hidden)');
    return String(label?.textContent || button.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function captureIntent(button, form) {
    const sticky = button.closest('[data-sticky-atc-add]');
    const gift = button.closest('.add-gift-btn');
    const videoCard = button.closest('.mlg-card-atc');
    const videoModal = button.closest('.mlg-btn-atc');
    if (!sticky && !gift && !videoCard && !videoModal && !form) return;

    const card = button.closest('[data-jiniu-product-context]');
    const stickyRoot = sticky?.closest('[data-sticky-atc]');
    const stickyForm = stickyRoot ? document.getElementById(stickyRoot.dataset.productFormId) : null;
    const giftItem = gift?.closest('.gift-item');
    const variantId = String(giftItem?.dataset.variantId || videoCard?.getAttribute('data-variant-id') || form?.querySelector('[name="id"]')?.value || stickyForm?.querySelector('[name="id"]')?.value || '');
    const source = sticky ? 'sticky_atc' : gift ? 'cart_gift' : videoModal ? 'product_video_modal' : videoCard ? 'product_video_card' : moduleName(card?.dataset.jiniuSource || form?.dataset.eventContext);
    pendingIntent = {
      createdAt: Date.now(),
      variantId,
      sourceModule: source,
      buttonText: buttonText(button),
      listPosition: card ? positionOf(card) : giftItem ? Number(giftItem.dataset.index) + 1 : '',
      formId: stickyForm?.id || form?.id || ''
    };
  }

  function captureClick(event) {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button');
    if (!button) return;
    const form = button.closest('form[action]');
    const addForm = form && isAddUrl(form.action) ? form : null;
    const specialAddButton = button.matches('[data-sticky-atc-add], .add-gift-btn, .mlg-card-atc, .mlg-btn-atc');
    if (addForm && !button.matches('[name="add"], .button-add-to-cart') && !specialAddButton) return;
    if (!addForm && !specialAddButton) return;
    captureIntent(button, addForm);
  }

  function captureSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isAddUrl(form.action)) return;
    if (pendingIntent?.sourceModule === 'sticky_atc' && pendingIntent.formId === form.id && Date.now() - pendingIntent.createdAt < intentLifetimeMs) return;
    if (event.submitter && !event.submitter.matches('[name="add"], .button-add-to-cart')) return;
    const button = event.submitter || form.querySelector('button[type="submit"], button[name="add"]');
    if (button) captureIntent(button, form);
  }

  document.addEventListener('click', function (event) {
    try { captureClick(event); } catch (error) { reportTrackingError('click capture failed'); }
  }, true);

  document.addEventListener('submit', function (event) {
    try { captureSubmit(event); } catch (error) { reportTrackingError('submit capture failed'); }
  }, true);

  function requestItemsFromBody(body) {
    let data = body;
    if (body instanceof FormData) {
      data = Object.fromEntries(body.entries());
    } else if (typeof body === 'string') {
      data = JSON.parse(body);
    }
    if (!data || typeof data !== 'object') return [];
    const rawItems = Array.isArray(data.items) ? data.items : [data];
    return rawItems.map(function (item) {
      return { variantId: String(item.id || ''), quantity: Number(item.quantity || 1) };
    }).filter(function (item) {
      return item.variantId && Number.isInteger(item.quantity) && item.quantity > 0;
    });
  }

  function readRequestItems(input, config) {
    if (config?.body !== undefined) return Promise.resolve(requestItemsFromBody(config.body));
    if (!(input instanceof Request)) return Promise.resolve([]);
    const copy = input.clone();
    const contentType = String(copy.headers.get('content-type') || '');
    if (contentType.includes('application/json')) return copy.text().then(requestItemsFromBody);
    if (contentType.includes('form')) return copy.formData().then(requestItemsFromBody);
    return Promise.resolve([]);
  }

  function money(subunits) {
    const value = Number(subunits);
    return Number.isFinite(value) ? Math.round(value) / 100 : 0;
  }

  function lineFor(responseItem, cart) {
    const lines = Array.isArray(cart?.items) ? cart.items : [];
    return lines.find(function (line) { return responseItem.key && line.key === responseItem.key; }) || lines.find(function (line) { return String(line.variant_id) === String(responseItem.variant_id); }) || responseItem;
  }

  function normalizedItems(requestItems, responseItems, cart, intent, addonPositions) {
    return requestItems.map(function (requested, index) {
      const responseItem = responseItems[index]?.variant_id && String(responseItems[index].variant_id) === requested.variantId ? responseItems[index] : responseItems.find(function (item) { return String(item.variant_id || item.id) === requested.variantId; });
      if (!responseItem) return null;
      const line = lineFor(responseItem, cart);
      const originalUnit = Number(line.original_price ?? line.price ?? responseItem.original_price ?? responseItem.price);
      const finalUnit = Number(line.final_price ?? responseItem.final_price ?? originalUnit);
      if (!Number.isFinite(originalUnit) || !Number.isFinite(finalUnit)) return null;
      const price = money(originalUnit);
      const discountAmount = Math.max(0, Math.round((originalUnit - finalUnit) * requested.quantity) / 100);
      return {
        product_id: String(responseItem.product_id || line.product_id || ''),
        product_name: String(responseItem.product_title || line.product_title || ''),
        product_handle: String(responseItem.handle || line.handle || ''),
        variant_id: requested.variantId,
        msku: String(responseItem.sku || line.sku || ''),
        product_type: String(responseItem.product_type || line.product_type || ''),
        price,
        quantity: requested.quantity,
        discount_amount: Math.min(Math.round(price * requested.quantity * 100) / 100, discountAmount),
        list_position: index === 0 ? intent.listPosition : addonPositions.get(requested.variantId) || ''
      };
    }).filter(Boolean);
  }

  async function currentCart() {
    const controller = new AbortController();
    const timeout = window.setTimeout(function () { controller.abort(); }, 1500);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await originalFetch.call(window, root + 'cart.js', { signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('cart snapshot HTTP failure');
      return await response.json();
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function processSuccessfulAdd(response, requestItemsPromise, intent, addons) {
    const requestItems = await requestItemsPromise;
    if (!requestItems.length || (intent.variantId && intent.variantId !== requestItems[0].variantId)) return;
    const added = await response.json();
    if (added.status) return;
    const responseItems = Array.isArray(added.items) ? added.items : [added];
    if (responseItems.length < requestItems.length) return;

    let cart = null;
    try {
      cart = await currentCart();
    } catch (error) {
      reportTrackingError('cart snapshot failed');
    }
    const addonPositions = new Map(addons.map(function (checkbox) {
      return [String(checkbox.value), positionOf(checkbox)];
    }));
    const items = normalizedItems(requestItems, responseItems, cart, intent, addonPositions);
    if (items.length !== requestItems.length) return;
    const addonSource = addons[0]?.closest('[data-jiniu-source]')?.dataset.jiniuSource;
    const payload = {
      source_module: addons.length ? moduleName(addonSource) : intent.sourceModule,
      button_text: intent.buttonText,
      cart_value: cart && Number.isFinite(Number(cart.total_price)) ? money(cart.total_price) : '',
      cart_item_count: cart && Number.isFinite(Number(cart.item_count)) ? Number(cart.item_count) : '',
      currency: String(cart?.currency || window.jiniuTrackingContext?.currency || ''),
      has_addon_relationship: addons.length > 0,
      items
    };
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') throw new Error('Shopify analytics publish unavailable');
    const dispatched = await publish.call(window.Shopify.analytics, 'jiniu:add_to_cart_confirmed', payload);
    if (dispatched === false) reportTrackingError('custom event dispatch rejected');
  }

  window.fetch = function (input, config) {
    const url = input instanceof Request ? input.url : input;
    const method = String(config?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    if (method !== 'POST' || !isAddUrl(url)) return originalFetch.call(this, input, config);

    const intent = pendingIntent && Date.now() - pendingIntent.createdAt < intentLifetimeMs ? pendingIntent : null;
    pendingIntent = null;
    if (!intent) return originalFetch.call(this, input, config);
    let requestItemsPromise;
    try {
      requestItemsPromise = readRequestItems(input, config).catch(function () {
        reportTrackingError('add request parsing failed');
        return [];
      });
    } catch (error) {
      reportTrackingError('add request parsing failed');
      return originalFetch.call(this, input, config);
    }
    const addons = Array.from(document.querySelectorAll('.addon-checkbox:checked:not([disabled])'));
    return originalFetch.call(this, input, config).then(function (response) {
      if (response.ok) {
        let trackingResponse;
        try {
          trackingResponse = response.clone();
        } catch (error) {
          requestItemsPromise.catch(function () { reportTrackingError('add request parsing failed'); });
          reportTrackingError('add response copy failed');
          return response;
        }
        requestItemsPromise.then(function (requestItems) {
          const selected = addons.filter(function (checkbox) { return requestItems.slice(1).some(function (item) { return item.variantId === String(checkbox.value); }); });
          return processSuccessfulAdd(trackingResponse, Promise.resolve(requestItems), intent, selected);
        }).catch(function () { reportTrackingError('confirmed add processing failed'); });
      } else {
        requestItemsPromise.catch(function () { reportTrackingError('add request parsing failed'); });
      }
      return response;
    }, function (error) {
      requestItemsPromise.catch(function () { reportTrackingError('add request parsing failed'); });
      throw error;
    });
  };
})();
